// En-tête du site public. Une div role="banner" plutôt qu'un <header> : App.css
// stylise la balise nue, avec des !important dans ses requêtes mobiles.
// Les ancres n'apparaissent que sur l'accueil ; connecté, l'utilisateur
// retrouve « Mon espace » et le dashboard web (messagerie, admin et
// déconnexion restent dans l'espace connecté).
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import appIcon from "../images/favicon.png";
import { isLoggedIn, getCurrentSubscription } from "../services/authService";
import { IconeFermer, IconeMenu } from "./Icones";

const ANCRES = [
	{ href: "#fonctionnalites", libelle: "Fonctionnalités" },
	{ href: "#coachs", libelle: "Coachs" },
	{ href: "#tarifs", libelle: "Tarifs" },
	{ href: "#faq", libelle: "FAQ" },
];

// Abonnements qui ouvrent le dashboard coach web (même règle que l'en-tête connecté).
const PALIERS_PRO = [4, 6];

// Le défilement se fait dans <body> (html à 100 %, App.css) : on lit les deux.
const hauteurDefilee = () =>
	Math.max(document.body.scrollTop, document.documentElement.scrollTop, window.scrollY || 0);

export default function SiteHeader() {
	const { pathname } = useLocation();
	const surAccueil = pathname === "/";
	const [connecte, setConnecte] = useState(isLoggedIn());
	const [estPro, setEstPro] = useState(false);
	const [defile, setDefile] = useState(false);
	const [menuOuvert, setMenuOuvert] = useState(false);

	useEffect(() => {
		const verifier = () => setConnecte(isLoggedIn());
		verifier();
		setMenuOuvert(false);
		window.addEventListener("storage", verifier);
		return () => window.removeEventListener("storage", verifier);
	}, [pathname]);

	useEffect(() => {
		let annule = false;
		if (!connecte) {
			setEstPro(false);
			return undefined;
		}
		getCurrentSubscription().then((resultat) => {
			if (annule) return;
			setEstPro(Boolean(resultat?.success && PALIERS_PRO.includes(resultat.subscription?.idAbonnementType)));
		});
		return () => {
			annule = true;
		};
	}, [connecte]);

	useEffect(() => {
		// Capture : les défilements de <body> ne remontent pas jusqu'à window.
		const surDefilement = () => setDefile(hauteurDefilee() > 8);
		surDefilement();
		window.addEventListener("scroll", surDefilement, { capture: true, passive: true });
		return () => window.removeEventListener("scroll", surDefilement, { capture: true });
	}, []);

	const actions = connecte ? (
		<>
			{/* Mêmes rôles que l'en-tête de l'espace connecté : dashboard web en
			    plein noir, le compte en contour. */}
			<Link to={estPro ? "/coach" : "/pro"} className="gs-btn gs-btn--plein gs-btn--petit gs-masque-mobile">
				Dashboard web
			</Link>
			<Link to="/dashboard" className="gs-btn gs-btn--contour gs-btn--petit">
				Mon espace
			</Link>
		</>
	) : pathname === "/login" ? null : (
		<Link to="/login" className="gs-btn gs-btn--plein gs-btn--petit">
			Connexion
		</Link>
	);

	return (
		<div className={`gs-entete${defile ? " gs-entete--defile" : ""}`} role="banner">
			<div className="gs-conteneur gs-entete-ligne">
				<Link to="/" className="gs-logo">
					<img src={appIcon} alt="" />
					<span>GymNote</span>
				</Link>

				{surAccueil && (
					<nav className="gs-nav" aria-label="Sections de la page">
						{ANCRES.map((a) => (
							<a key={a.href} href={a.href}>
								{a.libelle}
							</a>
						))}
					</nav>
				)}

				<div className="gs-entete-actions">
					{actions}
					{(surAccueil || connecte) && (
						<button
							type="button"
							className="gs-menu-bouton"
							aria-label={menuOuvert ? "Fermer le menu" : "Ouvrir le menu"}
							aria-expanded={menuOuvert}
							onClick={() => setMenuOuvert((v) => !v)}
						>
							{menuOuvert ? <IconeFermer taille={20} /> : <IconeMenu taille={20} />}
						</button>
					)}
				</div>
			</div>

			<div className="gs-menu-mobile" data-ouvert={menuOuvert}>
				{surAccueil &&
					ANCRES.map((a) => (
						<a key={a.href} href={a.href} onClick={() => setMenuOuvert(false)}>
							{a.libelle}
						</a>
					))}
				{connecte && (
					<Link to={estPro ? "/coach" : "/pro"} onClick={() => setMenuOuvert(false)}>
						Dashboard web
					</Link>
				)}
			</div>
		</div>
	);
}
